import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { HTMLTrans } from '../../Common/Translations';

class BeforeExtendVoucherBody extends PureComponent {
  render() {
    const {
      closeCallback,
      extendCallback,
      voucherCode,
      extendDate
    } = this.props;
    return (
      <div>
        <h2 className='ProximaNova-Bold'><HTMLTrans id="account.voucher_beforeextendvoucher_title">Extend Your Voucher</HTMLTrans></h2>
        <HTMLTrans id="account.voucher_beforeextendvoucher_description"
        variables={{"voucherCode": voucherCode, "extendDate": extendDate}}>
          <p>
            You have agreed to extend the validity of your voucher
            <span className='ProximaNova-Bold text-secondary text-uppercase mx-1'>
              {voucherCode}
            </span>
            to
            <span className='ProximaNova-Bold mx-1'>
              {extendDate}
            </span>
          </p>
        </HTMLTrans>
        <div className='mt-5'>
          <button
            className='btn btn-outline-primary mr-2'
            onClick={closeCallback}
          >
            <HTMLTrans id="account.voucher_beforeextendvoucher_button_cancel">CANCEL</HTMLTrans>
          </button>
          <button
            className='btn btn-primary'
            onClick={extendCallback}
          >
            <HTMLTrans id="account.voucher_beforeextendvoucher_button_extend">EXTEND</HTMLTrans>
          </button>
        </div>
      </div>
    );
  }
}

BeforeExtendVoucherBody.propTypes = {
  voucherCode: PropTypes.string,
  extendDate: PropTypes.string,
  closeCallback: PropTypes.func.isRequired,
  extendCallback: PropTypes.func.isRequired,
}

export default BeforeExtendVoucherBody;



// WEBPACK FOOTER //
// ./src/Account/Voucher/BeforeExtendVoucher.js